module.exports = __webpack_public_path__ + "1d08636aafd79dd583f55a2de0cba1b9.jpg";